
    module.exports = {
      render: function(){with(this){return _c('div',{staticClass:"app refineryGraphics"},[_c('overview')],1)}},
      staticRenderFns: []
    };
  


//////////////////
// WEBPACK FOOTER
// ./src/view/app.html
// module id = 190
// module chunks = 0